document.addEventListener('DOMContentLoaded', function () {
    const accordionTitles = document.querySelectorAll('.accordiantitle');
    
    accordionTitles.forEach(title => {
        title.addEventListener('click', function () {
            const target = document.querySelector(title.getAttribute('data-target'));

            // Toggle the accordion body visibility
            target.classList.toggle('open');
        });
    });
});


document.addEventListener('DOMContentLoaded', function() {
    // Select all Lottie player elements by their IDs (lottie1, lottie2, lottie3)
    const lottieElements = document.querySelectorAll('[id^="lottie"]'); // This will target all elements with IDs starting with "lottie"

    // Create an Intersection Observer to trigger when each element enters the viewport
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Play the animation when it's in view
                entry.target.play();
                // Optionally, stop observing after it's played once
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 }); // Trigger when 50% of the element is in view

    // Start observing each Lottie element
    lottieElements.forEach(element => {
        observer.observe(element);
    });
});

// Show the pop-up when the button is clicked
document.getElementById("openPopup").onclick = function(event) {
  event.preventDefault(); // Prevent default action
  document.getElementById("popup").style.display = "flex"; // Show pop-up
};

// Hide the pop-up when the close button is clicked
document.querySelector(".popup-close").onclick = function() {
  document.getElementById("popup").style.display = "none"; // Hide pop-up
};

// Close the pop-up if clicked outside of it
window.onclick = function(event) {
  if (event.target === document.getElementById("popup")) {
    document.getElementById("popup").style.display = "none"; // Hide pop-up
  }
};